import React from 'react'
import ProductComponent from "./ProductComponent/ProductComponent";
import Page from "../../Page/Page";

const AddProduct = () => {
    return (
        <Page>
            <ProductComponent/>
        </Page>
    )
}

export default AddProduct
